/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/* Product tile width on 1536px screen size with current design (should be recalculated on design change) */
const PRODUCT_TILE_BREAKPOINT_WIDTH = 356
const getPLPVariantsCommonStyless = ({theme}) => ({
    container: {
        backgroundColor: `${theme.colors.stokkeGray.bright}80`,
        padding: {base: '0.75rem 0.75rem 1.5rem', md: '1.5rem'},
        _hover: {
            boxShadow: theme.shadows.productTile.plp,
            backgroundColor: 'stokkeCore.white'
        }
    },
    overlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: theme.gradients.greyBackgroundOfProductImages
    }
})

export default {
    baseStyle: ({theme}) => ({
        link: {
            display: 'block',
            maxWidth: PRODUCT_TILE_BREAKPOINT_WIDTH
        },
        hybridlink: {
            _focus: {
                display: 'block',
                border: '1px solid',
                borderColor: 'stokkeCore.black'
            }
        },
        container: {
            bg: 'stokkeCore.white',
            padding: '0.75rem 0.75rem 1.5rem',
            maxWidth: PRODUCT_TILE_BREAKPOINT_WIDTH,
            color: 'stokkeCore.black',
            _hover: {
                boxShadow: theme.shadows.productTile.default
            }
        },
        ratings: {
            height: '1.3rem'
        },
        price: {
            fontSize: '0.875rem',
            lineHeight: '130%',
            color: 'stokkeCore.black'
        },
        title: {
            fontSize: '1rem',
            lineHeight: '1.3rem',
            height: '3.9rem',
            color: 'stokkeCore.black',
            overflow: 'hidden'
        },
        plusOrPlpMoreColorsButton: {
            border: '1px',
            minWidth: 6,
            height: 6,
            width: 6,
            borderRadius: 'full',
            padding: 2,
            cursor: 'pointer',
            variant: 'outlined'
        },
        variations: {
            height: 6
        },
        quickshopButton: {
            position: 'absolute',
            bottom: 0,
            right: 0,
            _hover: {
                color: 'stokkeGray.accessibleText'
            }
        },
        plpMoreColorsTxt: {
            textStyle: 'Badge Regular'
        }
    }),
    variants: {
        'plp-unsliced': ({theme}) => getPLPVariantsCommonStyless({theme}),
        'plp-sliced': ({theme}) => getPLPVariantsCommonStyless({theme})
    },
    parts: ['container', 'imageWrapper', 'image', 'price', 'title', 'rating', 'variations']
}
